import type { IssueSeverity, IssueStatus } from "@/types/issue"

/**
 * The choices a filter or the raise form offers. An issue's own words (its
 * standing, severity and source) come from the API with it.
 */
const issueSeverities = [
  "high",
  "medium",
  "low",
] as const satisfies readonly IssueSeverity[]

const issueStatuses = [
  "open",
  "investigating",
  "mitigated",
  "closed",
] as const satisfies readonly IssueStatus[]

const issueSeverityLabels: Record<IssueSeverity, string> = {
  low: "Low",
  medium: "Medium",
  high: "High",
}

const issueStatusLabels: Record<IssueStatus, string> = {
  triage: "Triage",
  open: "Open",
  investigating: "Investigating",
  mitigated: "Mitigated",
  closed: "Closed",
}

export {
  issueSeverities,
  issueSeverityLabels,
  issueStatusLabels,
  issueStatuses,
}
